<template>
  <div class="race-question">
    <sweet-modal ref="bonusDistance" v-on:close="onClose">
       <!-- <span> {{finishDate}} &nbsp;&nbsp;&nbsp;  {{race.duration}}&nbsp;&nbsp;&nbsp;   {{race.name}}</span> -->
          <p class="title">Add Bonus Distance</p>
         <!-- <p style="color: red">{{details.runner.distance}}</p>
          <br/> -->
         <input type = "number" v-model="bonusdistance" id="newdistance" maxlength="255" name="newdistance" Placeholder="" style="width: 50%;"> Km
      <div>
        <div v-if ="error" class="error-msg"><span ><p style="color: red;">{{errorMsg}}</p></span></div>
        <br/>       
        <button class="btn btn--primary" id="save-distance"  v-on:click="Save(bonusdistance)" style="float:none">Save</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Vue from "vue"
import { SweetModal } from "sweet-modal-vue"
import RacesService from "../../../services/races"
import { db } from "../../../firebase"
import moment from 'moment'

export default {
  name: "bonus-distance-modal",
  data: () => ({
   bonusdistance:"",
   error:false,
   errorMsg:""
  }),
  props: {
    details: {},
    show: false
  },
  // firebase: {
  //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
  // },
  methods: {
    onClose() {
      this.bonusdistance=""
      this.error=false
      this.$emit("closed", true)
    },
    openBonusModal() {
      // console.log("in",this.details)
      console.log("isRunning",this.details.runner.isRunning)
      console.log("isNotSubscribed",this.details.runner.isNotSubscribed)
      console.log("isJoined",this.details.runner.isJoined)
      console.log("fbentry>>",this.$fbDbEntry)
      this.error=false
      this.errorMsg=""
      this.$refs.bonusDistance.open()
    },
    changeHandle(){
    },
    Save(distance) {
      if(!this.details.runner.isJoined){
        console.log("Runner not joined race")
        let body={
          "bonus":parseFloat(distance)*1000,
          "bonusKm":parseFloat(distance)
        }
        RacesService.updateBonusdistance(this.details.race.id,this.details.runner.id,body).then(response => {          
            this.$refs.bonusDistance.close()
            this.error=false
            this.errorMsg=""
          }).catch(error => {
            console.log("err---",error.data)
            this.error=true
            this.errorMsg = error.data &&  error.data.message?error.data.message:""
            //this.$refs.bonusDistance.close()
        }) 
      }else{
        console.log("Runner joined race***")
        db.ref(`/${this.$fbDbEntry}/${this.details.race.id}/runners/${this.details.runner.id}`).update({                    
            'bonus': parseFloat(distance)*1000,                  
        })
        this.$refs.bonusDistance.close()
      }
      
    }
  },
  created() {
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openBonusModal()
      }
    }
  },
  components: {
    SweetModal
  }
}
</script>
<style>
p.title {
  color: #9c9c9c;
  font-size: 15px;
  padding: 10px;
}
.runnerName {
  padding: 10px;
}
.gift select {
  height: 35px;
  width: 75%;
  background: transparent;
}
.gift {
  padding: 20px 0px;
}
.luckyRunner .sweet-modal {
  border-radius: 30px;
}
.gift select:invalid {
  color: gray;
}
.errorMsg {
  padding: 10px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// BonusDistanceModal.vue?6aa34f11